import { useContactManagementTranslation } from '../../../../../../ui/hooks';
import { DataTree, useDataTreeUsingState } from '@juvare/common-data-table-ui/DataTree';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, FormLabel, useMediaQuery } from '@mui/material';
import React from 'react';
import { useOrganizationsSelectionTreeAnonymous } from '../../../hooks/useOrganizationSelectionTreeAnonymous';
import { showOrganizationTreeDialogAnonymous } from '../../OrganizationsTreeDialog/OrganizationsTreeDialogAnonymous';
export const OrganizationsSelectionAnonymous = (props) => {
    const { t } = useContactManagementTranslation();
    const downSmScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const { dataTreeProps, selectedOrganizationIds } = useOrganizationsSelectionTreeAnonymous({
        useDataTreeFunction: useDataTreeUsingState,
        filteredOrganizationsIds: props.organizationIds,
    });
    return (React.createElement("div", { "data-test": 'select-organizations-table' },
        React.createElement(Box, { sx: [{ mb: 2 }, downSmScreen ? { mt: 1 } : {}] },
            React.createElement(Button, { startIcon: React.createElement(AddIcon, null), "data-test": 'add-organizations-button', color: 'primary', variant: 'outlined', onClick: () => {
                    showOrganizationTreeDialogAnonymous({
                        initialSelectedOrganizationIds: props.organizationIds,
                        showSelectAllChildren: props.showSelectAllChildren,
                        multiSelect: true,
                        onChange: (addedOrganizationIds) => {
                            props.onChangeOrganizationIds(Array.from(new Set([...props.organizationIds, ...addedOrganizationIds])));
                        },
                    });
                } }, props.addLabel || t('panels.organizations.addOrgs')),
            selectedOrganizationIds && selectedOrganizationIds.length > 0 && (React.createElement(Button, { "data-test": 'remove-organizations-button', sx: [{ ml: 2 }, downSmScreen ? { display: 'block', mt: 1, ml: 0 } : {}], color: 'primary', variant: 'outlined', onClick: () => {
                    var _a;
                    (_a = dataTreeProps.onChangeSelectedItemIds) === null || _a === void 0 ? void 0 : _a.call(dataTreeProps, () => props.organizationIds.filter((organizationId) => !selectedOrganizationIds.includes(organizationId)));
                    props.onChangeOrganizationIds(props.organizationIds.filter((organizationId) => !selectedOrganizationIds.includes(organizationId)));
                } }, t('panels.organizations.removeOrgs')))),
        props.organizationIds.length > 0 && (React.createElement(DataTree, Object.assign({}, dataTreeProps, { border: true, getItemLabel: (item) => item.name, itemSelectionEnabled: true }))),
        props.organizationIds.length === 0 && !props.hideValidationMessage && (React.createElement(FormLabel, { required: !!props.organizationSelectionRequired, sx: {
                '& .MuiFormLabel-asterisk': {
                    color: (theme) => theme.palette.error.main,
                },
                '& .MuiFormLabel-root': {
                    color: (theme) => theme.palette.text.primary,
                },
            } }, t('panels.organizations.noOrgsSelected')))));
};
